export const APP_ENV_PRODUCTION = 'production'
export const APP_ENV_LOCAL = 'local'

export function isProductionAppEnv(appEnv: string): boolean {
  return appEnv === APP_ENV_PRODUCTION
}
